export const getToken = () => localStorage.getItem('token');
export const setToken = (token: string) => localStorage.setItem('token', token);
export const removeToken = () => localStorage.removeItem('token');

export const getUserType = () => {
  if (localStorage.getItem('userType')) {
    return localStorage.getItem('userType');
  }
  return 'customer';
};
export const setUserType = (userType: string) => {
  localStorage.setItem('userType', userType);
};
export const removeUserType = () => localStorage.removeItem('userType');

export const getTokenExpiresAt = () => localStorage.getItem('tokenExpiresAt');
export const setTokenExpiresAt = (expiresAt: string) =>
  localStorage.setItem('tokenExpiresAt', expiresAt);
export const removeTokenExpiresAt = () => localStorage.removeItem('tokenExpiresAt');

export const getCurrentDistributor = () => localStorage.getItem('currentDistributor');
export const setCurrentDistributor = (distributorId: string) =>
  localStorage.setItem('currentDistributor', distributorId);
export const removeCurrentDistributor = () => localStorage.removeItem('currentDistributor');

export const getAuthMethod = () => localStorage.getItem('authMethod') as 'legacy' | 'auth0' | null;
export const setAuthMethod = (method: 'legacy' | 'auth0') =>
  localStorage.setItem('authMethod', method);
export const removeAuthMethod = () => localStorage.removeItem('authMethod');
